import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SiteProvider } from "@/contexts/SiteContext";
import PublicLayout from "@/components/layout/PublicLayout";
import RequireAuth from "@/components/RequireAuth";

import Home from "@/pages/Home";
import About from "@/pages/About";
import { ServicesList, ServiceDetail } from "@/pages/Services";
import { ProjectsList, ProjectDetail } from "@/pages/Projects";
import Availabilities from "@/pages/Availabilities";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Analytics from "@/components/Analytics";

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <Analytics />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/societe" element={<About />} />
              <Route path="/prestations" element={<ServicesList />} />
              <Route path="/prestations/:slug" element={<ServiceDetail />} />
              <Route path="/projets" element={<ProjectsList />} />
              <Route path="/projets/:slug" element={<ProjectDetail />} />
              <Route path="/disponibilites" element={<Availabilities />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/legal/:slug" element={<Legal />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<RequireAuth><AdminDashboard /></RequireAuth>} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
